import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import ReactHtmlParser from '@orrisroot/react-html-parser';
import useViewport from 'utils/useViewportHelper';
import Button from 'shared/components/Button/Button';
import { INELIGIBLE_ALREADY_RENEWED } from 'constants/policyInfoConstants';
import { ROOT } from 'constants/routeConstants';
import { getState } from 'store';

interface RenewalErrorState {
  eligibility?: string;
  isPaymentError?: boolean;
  renewalPhoneInRequired?: boolean;
}

interface ErrorContent {
  title: string;
  description: string;
}

const RenewalError = () => {
  const { customer: { custInfo } } = getState();
  const [pageModel, setPageModel] = useState<ErrorContent>();

  const state = useLocation().state as RenewalErrorState | null;
  const { isMobile } = useViewport();

  const navigate = useNavigate();

  const description = '<p>Thank you for trying to renew your RAC Breakdown Cover. We’re sorry, you can’t renew this policy online.</p><p>Don’t worry, we’ll be happy to help over the phone. Just give us a call on <span class="orange"><b>0330 159 1111</b></span> to renew your cover.</p>';

  useEffect(() => {
    if (state) {
      if (!state?.eligibility && !state?.isPaymentError) {
        setPageModel({
          title: 'Sorry, we need to speak with you.',
          description,
        });
      }
      if (state?.isPaymentError) {
        setPageModel({
          title: 'Sorry, something went wrong with your payment.',
          description: '<p>Thank you for trying to renew your RAC Breakdown Cover.</p><p>We’re sorry but your payment has been unsuccessful. Please double-check your payment details or give us a call on <span class="orange"><b>0330 159 1111</b></span>.</p>',
        });
      }
      if (state?.eligibility && !state?.isPaymentError) {
        switch (state?.eligibility) {
          case INELIGIBLE_ALREADY_RENEWED:
            setPageModel({
              title: `Thanks ${custInfo.Forename}, you’ve renewed your cover.`,
              description: `We’ve sent you an email confirming your cover to ${custInfo.Email}. It contains essential information for RAC members. If you haven’t received it, please check your junk or spam folder.`,
            });
            break;
          default:
            setPageModel({
              title: 'Sorry, we need to speak with you.',
              description,
            });
        }
      }
      if (state.renewalPhoneInRequired) {
        setPageModel({
          title: 'Sorry, we need to speak with you.',
          description: '<p>Thank you for trying to renew your RAC Breakdown Cover. We’re sorry, you can’t renew this policy online.</p><strong>Don’t worry, we’ll be happy to help over the phone. Just give us a call on 0330 159 1111 to renew your cover.</strong>',
        });
      }
    } else {
      setPageModel({
        title: 'Sorry, we need to speak with you.',
        description,
      });
    }
  }, []);

  return (
    <div className={isMobile ? 'container-fluid px-3' : 'container p-5'}>
      <div className="row">
        <div className="col-md-12">
          <h2 className={`${isMobile ? 'pt-4' : 'p-0'}`}>
            {pageModel?.title}
          </h2>
          <div
            className={`d-flex w-100 ${isMobile ? 'flex-column my-3' : 'my-4'}`}
            style={{ fontSize: '1rem', minHeight: isMobile ? undefined : '296px' }}
          >
            <div
              className={`d-flex flex-column justify-content-between p-4 ${isMobile ? 'w-100' : 'w-50'}`}
              style={{
                backgroundColor: '#ededed',
                borderBottom: isMobile ? 'none' : '60px solid #ededed',
              }}
            >
              {ReactHtmlParser(pageModel?.description ?? '')}
            </div>
            <div
              className={isMobile ? 'w-100 d-flex justify-content-center' : 'w-50'}
              style={{
                backgroundColor: '#ededed',
                borderRight: isMobile ? 'none' : '300px solid #fff',
              }}
            >
              <div
                style={{
                  width: isMobile ? '300px' : '350px',
                  height: isMobile ? '300px' : '350px',
                  background: "url('https://images.contentstack.io/v3/assets/bltab270fecbe9695fb/blt080210fb599f5f01/62582c9b02d8144fd4dab6a0/Maintenance_Desktop.png') no-repeat",
                  backgroundSize: isMobile ? 'contain' : 'auto',
                  ...(isMobile ? {} : { position: 'absolute', top: '260px' }),
                }}
              />
            </div>
          </div>
          <div className={`mb-4 ${isMobile ? 'w-100' : 'w-50'}`}>
            <Button
              onClickHandler={() => navigate(ROOT)}
              buttonText="Back to MyRAC"
              chevronWhite
              fullWidth
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default RenewalError;
